export default __webpack_public_path__ + "static/instagram-hero-1-29aa8f30d43adf7bd1d6d1f19d24076c.png";